/**
 * @generated SignedSource<<073d552d7a02814cb83d6f222230ff32>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutPayPalWrapper_viewer$data = {
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"usePayPalClient_viewer">;
  readonly " $fragmentType": "CheckoutPayPalWrapper_viewer";
};
export type CheckoutPayPalWrapper_viewer$key = {
  readonly " $data"?: CheckoutPayPalWrapper_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutPayPalWrapper_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutPayPalWrapper_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "usePayPalClient_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "a7b45ef297a088df62df3577532e2a16";

export default node;
